import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_DOCECHEANCE_SCHEMA_LITERAL = {
    title: 'Schéma F_DOCREGL',
    description: 'Document',
    version: 0,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        PK_ID : { type : 'string', maxLength : 100 },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        USER_ID: { type: 'string' },
        MD_CBMARQ : { type : 'number' },
        DR_NO_INTERNAL : { type : 'number' },
        DO_PIECE : { type : 'string' },
        DO_PIECE_INTERNAL : { type : 'string' },
        DR_DATE : { type : 'string' },
        DR_LIBELLE : { type : ['string', 'null'] },
        N_REGLEMENT : { type : 'string' },
        N_REGLEMENTLIB : { type : 'string' },
        DR_POURCENT : { type : 'number', default : 0 },
        DR_EQUIL : { type : 'number', default : 0 },
        DR_MONTANT : { type : 'number', default : 0 },
        DR_MONTANTDEV : { type : 'number', default : 0 },
        DR_REGLE : { type : 'number', default : 0 },
        DR_TYPEREGL : { type : 'number', default : 2 }
    },
    required: [ 'DR_NO_INTERNAL', 'DR_DATE', 'MD_CBMARQ']
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_DOCECHEANCE_SCHEMA_LITERAL);
export type RxCluDocEcheanceDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_DOCECHEANCE_SCHEMA: RxJsonSchema<RxCluDocEcheanceDocumentType> = CLU_DOCECHEANCE_SCHEMA_LITERAL;
